import {DeFiConnectProvider} from "@deficonnect/provider";

export const providerOptions = {
    "custom-deficonnect": {
        display: {
            name: "Crypto.com DeFi Wallet",
            description: "Connect to Crypto.com DeFi Wallet",
            logo: "https://crypto.com/defi/swap/favicon.c5a5b109.png",
        },
        package: DeFiConnectProvider,
        options: {
            rpcUrls: {
                25: "https://evm.cronos.org/", // cronos mainet
            },
            chainType: "eth",
            chainId: "25",
        },
        connector: async (ProviderPackage, options) => {
            const provider = new ProviderPackage(options);
            await provider.enable();
            return provider;
        },
    },
}
